// extracted by mini-css-extract-plugin
export default {"container":"elk55D","dashboardContainer":"GxFJkR"};